import { formValueSelector } from 'redux-form';
import uniqBy from 'lodash/uniqBy';
import { Tier } from '@eti/schema-types';
import { price as priceUtils } from '@eti/utils';
import useDarkMode from '../../custom-hooks/useDarkMode';
import { BUNDLE_PRODUCT } from './constants';
export const getSelected = (name, form) => state => {
  var _formData$value;
  const formData = formValueSelector(form)(state, name);
  return (_formData$value = formData === null || formData === void 0 ? void 0 : formData.value) !== null && _formData$value !== void 0 ? _formData$value : null;
};
export const getGraphQlSelection = ({
  state,
  form
}) => getSelected(BUNDLE_PRODUCT, form)(state);
const getPrice = (value, options = []) => (options.find(({
  type
}) => type === value) || {}).priceRaw || 0;
const getId = (value, options = []) => (options.find(({
  type
}) => type === value) || {}).id || null;
export const formatSet = options => value => {
  return {
    value: value || null,
    price: getPrice(value, options),
    id: getId(value, options)
  };
};
export const formatGet = bundle => bundle ? bundle.value : null;
export const orderBundles = type => {
  switch (type) {
    case Tier.Basic:
      return {
        desktopOrder: 1,
        mobileOrder: 3
      };
    case Tier.Recommended:
    case Tier.Premium:
    default:
      return {
        desktopOrder: 2,
        mobileOrder: 1
      };
  }
};
export const getBundleName = item => `${BUNDLE_PRODUCT}.${item.id}`;
export const getBundlePosition = (options, selectedType) => {
  return options.findIndex(({
    type
  }) => type === selectedType);
};
export const getNewActiveBundle = (options = [], selectedBundleToOpen) => options.filter(currentBundle => {
  const bundleName = getBundleName(currentBundle);
  return bundleName === selectedBundleToOpen;
})[0];
export const getUniqFeatures = (options = []) => uniqBy(options.reduce((acc, {
  features,
  title
}) => {
  const featuresWithTitle = features.map(feature => ({
    ...feature,
    title
  }));
  return [...acc, ...featuresWithTitle];
}, []), 'name');
export const getRowsData = options => getUniqFeatures(options).map(({
  description,
  name,
  pieces,
  weight,
  weightUnit,
  productTypeId
}, rowIndex) => ({
  productTypeId,
  description,
  name,
  optionColumns: options.map(({
    features,
    type,
    id,
    title
  }) => ({
    included: Boolean(features.find(({
      name: optionName
    }) => optionName === name)),
    isRecommended: type === Tier.Recommended,
    optionId: id,
    title
  })),
  pieces,
  rowIndex,
  weight,
  weightUnit
}));
export const getPriorities = recommendedPriority => ({
  BASIC: 0,
  RECOMMENDED: recommendedPriority,
  PREMIUM: recommendedPriority === 1 ? 2 : 1,
  DELUXE: 3
});
const prioritiesMobile = {
  RECOMMENDED: 0,
  DELUXE: 1,
  PREMIUM: 2,
  BASIC: 3
};
export const sortOptions = (options = []) => {
  const recommendedPriority = Math.max((options === null || options === void 0 ? void 0 : options.length) - 2, 1);
  const priorities = getPriorities(recommendedPriority);
  return [...options].sort((a, b) => priorities[a.type] - priorities[b.type]);
};
export const mobileBundleOptionOrder = sellableOptions => [...sellableOptions].sort((a, b) => prioritiesMobile[a.type] - prioritiesMobile[b.type]);
export const useStylesVariables = () => {
  const {
    isDarkMode
  } = useDarkMode();
  return {
    firstColumnWidth: 'calc(100% / 3)',
    recommendedBackground: isDarkMode ? '#484848' : '#fafafa',
    rowsHeight: '56px'
  };
};
export const formatPrice = price => `+${priceUtils.formatPrice(price)}`;
export const formatOriginalPrice = price => `${priceUtils.formatPrice(price)}`;
//# sourceMappingURL=utils.js.map